"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _dealerLocator = _interopRequireDefault(require("../styles/dealer-locator.css"));
var _mapStyles = _interopRequireDefault(require("../js/mapStyles"));
var _types = _interopRequireDefault(require("./types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var markerArr = [];
var currentMapWithLocationSettings;
var mapRef;

// let geocoder;

var searchZoomLevels = [{
  minDistance: 1,
  zoom: 13
}, {
  minDistance: 1.3,
  zoom: 12
}, {
  minDistance: 1.6,
  zoom: 11
}, {
  minDistance: 1.9,
  zoom: 10
}];

// temp custom event handler from document.body
// event is dispatched from dealer-list component
// and contains the id of the dealer needed to match the
// marker that should also be in hovered state

function handleAddHoveredStyle(event, el) {
  el.classList.add(_dealerLocator["default"].hoveredPin);
}
function handleRemoveHoveredStyle(event, el) {
  el.classList.remove(_dealerLocator["default"].hoveredPin);
}
function handleRemoveClickedStyle(event, el) {
  el.classList.add(_dealerLocator["default"].clickedPin);
}
var MapNew = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(MapNew, _Component);
  MapNew.removeAllCustomEventListenersById = function removeAllCustomEventListenersById(_refinedDealerList) {
    _refinedDealerList.forEach(function (dealer) {
      document.body.removeEventListener("mouseEnterListItem" + dealer.id, function (event) {
        return handleAddHoveredStyle(event, _marker.markerContent_.childNodes[0]);
      }, false);
      document.body.removeEventListener("mouseOutListItem" + dealer.id, function (event) {
        return handleRemoveHoveredStyle(event, _marker.markerContent_.childNodes[0]);
      }, false);
      document.body.removeEventListener("mouseClickListItem" + dealer.id, function (event) {
        return handleRemoveClickedStyle(event, _marker.markerContent_.childNodes[0]);
      }, false);
    });
  };
  MapNew.checkForMouseHover = function checkForMouseHover(fn, hoverIn, hoverOut) {
    return !hoverIn && !hoverOut ? fn : true;
  };
  MapNew.isEqualArray = function isEqualArray(arr1, arr2) {
    for (var i = 0; i < arr1.length; i += 1) {
      if (arr1[i].id !== arr2[i].id) {
        return false;
      }
    }
    return true;
  };
  MapNew.replaceLanguageMasters = function replaceLanguageMasters(region) {
    return region === 'language-masters' ? 'gb' : region;
  };
  function MapNew(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.map = /*#__PURE__*/_react["default"].createRef();
    _this.userMarkerContainer = /*#__PURE__*/_react["default"].createRef();
    _this.markerInner = /*#__PURE__*/_react["default"].createRef();
    _this.markerDot = /*#__PURE__*/_react["default"].createRef();
    _this.markercluster = /*#__PURE__*/_react["default"].createRef();
    _this.marker = /*#__PURE__*/_react["default"].createRef();
    _this.markerLabel = /*#__PURE__*/_react["default"].createRef();
    _this.loadMap = _this.loadMap.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMarkerClick = _this.onMarkerClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.addPinsToMap = _this.addPinsToMap.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setAndBindAutoComplete = _this.setAndBindAutoComplete.bind((0, _assertThisInitialized2["default"])(_this));
    _this.loadedType = props.selectedType;
    return _this;
  }
  var _proto = MapNew.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.loadMap();
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props = this.props,
      selectedDealer = _this$props.selectedDealer,
      googleMapSettings = _this$props.googleMapSettings,
      refinedDealerList = _this$props.refinedDealerList,
      hoveredDealer = _this$props.hoveredDealer;
    if ((selectedDealer && selectedDealer.id) !== (nextProps.selectedDealer && nextProps.selectedDealer.id)) {
      return true;
    }
    var isMapCenterSame = nextProps.googleMapSettings.center === googleMapSettings.center;
    var isSameDealerListLoose = refinedDealerList && nextProps.refinedDealerList && refinedDealerList.length > 0 && nextProps.refinedDealerList.length > 0 && refinedDealerList[0].id === nextProps.refinedDealerList[0].id && refinedDealerList.length === nextProps.refinedDealerList.length;
    if (isMapCenterSame && isSameDealerListLoose && MapNew.checkForMouseHover(MapNew.isEqualArray(refinedDealerList, nextProps.refinedDealerList), hoveredDealer, nextProps.hoveredDealer)) {
      return false;
    }
    if (nextProps.isInitialMapLoad) {
      if (selectedDealer === undefined && nextProps.selectedDealer !== undefined || (selectedDealer && selectedDealer.id) !== (nextProps.selectedDealer && nextProps.selectedDealer.id) || this.loadedType !== nextProps.selectedType) {
        return true;
      }
      return false;
    }
    return true;
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.loadMap();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var refinedDealerList = this.props.refinedDealerList;
    MapNew.removeAllCustomEventListenersById(refinedDealerList);
  }

  // figure out which dealer pin is
  ;
  _proto.onMarkerClick = function onMarkerClick(el, _maps) {
    var _this$props2 = this.props,
      refinedDealerList = _this$props2.refinedDealerList,
      updateSelectedDealer = _this$props2.updateSelectedDealer,
      selectedDealer = _this$props2.selectedDealer;
    var _ref = selectedDealer || {},
      address = _ref.address;
    var _ref2 = address || {},
      latitude = _ref2.latitude,
      longitude = _ref2.longitude;
    var markerPos = el.getPosition();
    if (selectedDealer) {
      var selectedDealerPos = new _maps.LatLng(latitude, longitude);
      if (markerPos.equals(selectedDealerPos)) return;
    }
    if (refinedDealerList && refinedDealerList.length > 0) {
      refinedDealerList.forEach(function (dealer) {
        var dealerPos = new _maps.LatLng(dealer.address.latitude, dealer.address.longitude);
        if (markerPos.equals(dealerPos)) {
          updateSelectedDealer(dealer);
        }
      });
    }
  };
  _proto.setAndBindAutoComplete = function setAndBindAutoComplete(_maps, _currentMapWithLocationSettings) {
    var _this$props3 = this.props,
      onPlaceChange = _this$props3.onPlaceChange,
      region = _this$props3.region;
    var input = document.querySelector("#" + _dealerLocator["default"].searchDealers);
    var autocomplete = new _maps.places.Autocomplete(input, {
      types: ['(regions)'],
      componentRestrictions: {
        country: MapNew.replaceLanguageMasters(region)
      }
    });
    autocomplete.bindTo('bounds', _currentMapWithLocationSettings);
    autocomplete.addListener('place_changed', function () {
      onPlaceChange(_maps);
    });
  };
  MapNew.setUserMarker = function setUserMarker(_userLocation, _userMarkerContainer, _currentMapWithLocationSettings, _maps) {
    var _userMarker = new window.RichMarker({
      position: new _maps.LatLng(_userLocation.lat, _userLocation.lng),
      map: _currentMapWithLocationSettings,
      draggable: false,
      content: _userMarkerContainer.current.innerHTML,
      shadow: false
    });
    window.userMarker = _userMarker;
  };
  _proto.loadMap = function loadMap() {
    var _this$props4 = this.props,
      refinedDealerList = _this$props4.refinedDealerList,
      googleMapSettings = _this$props4.googleMapSettings,
      google = _this$props4.google,
      userLocation = _this$props4.userLocation,
      setInitialMapGeocodeFromCountryCode = _this$props4.setInitialMapGeocodeFromCountryCode,
      isInitialMapLoad = _this$props4.isInitialMapLoad,
      selectedType = _this$props4.selectedType,
      selectedDealer = _this$props4.selectedDealer,
      zoomLevel = _this$props4.zoomLevel;
    if (this.props && google) {
      this.loadedType = selectedType;

      // google is available, google instance is given to us on props via HOC via googleAPI

      // google API reference
      var maps = google.maps;

      // current map instance reference via createRef()
      mapRef = this.map.current;

      // current native DOM node the map is on
      // eslint-disable-next-line react/no-find-dom-node
      var mapDOMNode = _reactDom["default"].findDOMNode(mapRef);

      // these are passed in google map settings from props
      var zoom = googleMapSettings.zoom,
        _googleMapSettings$ce = googleMapSettings.center,
        lat = _googleMapSettings$ce.lat,
        lng = _googleMapSettings$ce.lng;
      var latitude = lat;
      var longitude = lng;
      var adjustedZoom = zoom || 12;
      if (selectedDealer && selectedDealer.address) {
        // Zoom in close when dealer is selected
        latitude = selectedDealer.address.latitude;
        longitude = selectedDealer.address.longitude;
        adjustedZoom = zoomLevel || 16;
      } else if (!isInitialMapLoad && refinedDealerList && refinedDealerList.length > 1) {
        // Determine zoom level based on pin spread
        var bounds = {};
        refinedDealerList.forEach(function (_ref3) {
          var address = _ref3.address;
          if (address.latitude > bounds.upper || bounds.upper === undefined) {
            bounds.upper = address.latitude;
          }
          if (address.latitude < bounds.lower || bounds.lower === undefined) {
            bounds.lower = address.latitude;
          }
          if (address.longitude > bounds.left || bounds.left === undefined) {
            bounds.left = address.longitude;
          }
          if (address.longitude < bounds.right || bounds.right === undefined) {
            bounds.right = address.longitude;
          }
        });
        var latDiff = Math.abs(bounds.upper - bounds.lower);
        var lngDiff = Math.abs(bounds.right - bounds.left);
        for (var i = 0; i < searchZoomLevels.length; i += 1) {
          if (latDiff > searchZoomLevels[i].minDistance || lngDiff > searchZoomLevels[i].minDistance) {
            adjustedZoom = searchZoomLevels[i].zoom;
          } else {
            break;
          }
        }
      }
      var center = new maps.LatLng(latitude, longitude);
      var mapConfig = {
        center: center,
        zoom: adjustedZoom,
        mapTypeId: maps.MapTypeId.ROADMAP,
        mapTypeControlOptions: {
          mapTypeIds: [google.maps.MapTypeId.ROADMAP]
        },
        styles: _mapStyles["default"],
        disableDefaultUI: true,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true
      };
      var initialMapConfig = {
        center: center,
        mapTypeId: maps.MapTypeId.ROADMAP,
        mapTypeControlOptions: {
          mapTypeIds: [google.maps.MapTypeId.ROADMAP]
        },
        styles: _mapStyles["default"],
        disableDefaultUI: true,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true
      };
      currentMapWithLocationSettings = new maps.Map(mapDOMNode, mapConfig);
      if (isInitialMapLoad && !selectedDealer) {
        currentMapWithLocationSettings = new maps.Map(mapDOMNode, initialMapConfig);
        setInitialMapGeocodeFromCountryCode(maps, currentMapWithLocationSettings);
      } else {
        currentMapWithLocationSettings = new maps.Map(mapDOMNode, mapConfig);
      }
      this.setAndBindAutoComplete(maps, currentMapWithLocationSettings);
      MapNew.setUserMarker(userLocation, this.userMarkerContainer, currentMapWithLocationSettings, maps);
      if (refinedDealerList && refinedDealerList.length > 0) {
        markerArr = []; // Reset array size before dropping pins again

        this.addPinsToMap(refinedDealerList, currentMapWithLocationSettings, maps);
        window.markerClusterer = new window.MarkerClusterer(currentMapWithLocationSettings, markerArr, {
          clusterClass: this.markercluster.current.className
        });
      }
    }
    // this.forceUpdate();
  };
  _proto.addPinsToMap = function addPinsToMap(_refinedDealerList, _currentMapWithLocationSettings, _maps) {
    var _this2 = this;
    var _this$props5 = this.props,
      updateHoveredDealer = _this$props5.updateHoveredDealer,
      selectedDealer = _this$props5.selectedDealer;
    _refinedDealerList.forEach(function (dealer) {
      _this2.markerLabel.current.setAttribute('aria-label', dealer.name);
      _this2.markerLabel.current.innerHTML = "<span aria-hidden=\"true\">" + dealer.pinLabel + "</span>";
      var _marker = new window.RichMarker({
        position: new _maps.LatLng(dealer.address.latitude, dealer.address.longitude),
        map: _currentMapWithLocationSettings,
        draggable: false,
        content: _this2.marker.current.innerHTML,
        shadow: false,
        markerId: dealer.id
      });
      _marker.addListener('click', function () {
        _this2.onMarkerClick(_marker, _maps);
      });
      _maps.event.addListener(_marker, 'mouseover', function () {
        updateHoveredDealer(dealer);
      });
      _maps.event.addListener(_marker, 'mouseout', function () {
        updateHoveredDealer(undefined);
      });
      _maps.event.addListener(_marker, 'ready', function () {
        if (selectedDealer && selectedDealer.id === _marker.markerId) {
          _marker.markerContent_.childNodes[0].classList.add(_dealerLocator["default"].clickedPin);
        }
      });
      document.body.addEventListener("mouseEnterListItem" + dealer.id, function (event) {
        return _marker.markerContent_.childNodes.length > 0 && handleAddHoveredStyle(event, _marker.markerContent_.childNodes[0]);
      }, false);
      document.body.addEventListener("mouseOutListItem" + dealer.id, function (event) {
        return _marker.markerContent_.childNodes.length > 0 && handleRemoveHoveredStyle(event, _marker.markerContent_.childNodes[0]);
      }, false);
      markerArr = [].concat(markerArr, [_marker]);
    });
  };
  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      id: "#map",
      ref: this.map,
      className: _dealerLocator["default"].container
    }, /*#__PURE__*/_react["default"].createElement("span", {
      ref: this.markercluster,
      className: _dealerLocator["default"].markercluster
    }), /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.marker,
      className: _dealerLocator["default"].markerwrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.markerInner,
      className: _dealerLocator["default"].pin
    }, /*#__PURE__*/_react["default"].createElement("span", {
      ref: this.markerLabel,
      className: _dealerLocator["default"].label
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.userMarkerContainer,
      className: _dealerLocator["default"].markerwrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerLocator["default"].userPin
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.markerInner,
      className: _dealerLocator["default"].pin
    }, /*#__PURE__*/_react["default"].createElement("span", {
      ref: this.markerDot,
      className: _dealerLocator["default"].dot
    }))))));
  };
  return MapNew;
}(_react.Component);
exports["default"] = MapNew;
MapNew.defaultProps = {
  refinedDealerList: []
};